import { CSSProperties, ReactElement } from 'react';

import { Container } from '@/components/Container';

interface IKeyValuePair {
  keyName: string;
  value: string | number | ReactElement;
  valueColor?: CSSProperties['color'];
  valueFontWeight?: CSSProperties['fontWeight'];
  vertical?: boolean;
  addColon?: boolean;
  maxHeight?: CSSProperties['maxHeight'];
  textAlign?: CSSProperties['textAlign'];
}

export const KeyValuePair = ({
  addColon = false,
  vertical = false,
  keyName,
  value,
  valueColor,
  valueFontWeight,
  maxHeight,
  textAlign = 'unset',
}: IKeyValuePair) => {
  return (
    <Container
      className={'key-value-pair'}
      debugColor={'blue'}
      sx={{
        textAlign,
        margin: 'unset',
        display: 'flex',
        flexDirection: vertical ? 'column' : 'row',
        fontSize: 12,
      }}
    >
      <Container
        debugColor={'red'}
        sx={{
          width: 'initial',
          flexGrow: 0,
          marginLeft: 'unset',
          marginRight: vertical ? 'unset' : '4px',
          fontWeight: 'bold',
          whiteSpace: 'nowrap',
        }}
      >
        {keyName}
        {addColon ? ':' : ''}
      </Container>
      <Container
        debugColor={'red'}
        sx={{
          width: 'initial',
          flexGrow: 1,
          color: valueColor,
          fontWeight: valueFontWeight,
          margin: 'unset',
          maxHeight,
        }}
      >
        {value}
      </Container>
    </Container>
  );
};
